module.exports = __webpack_public_path__ + "static/media/download-icon.cc8e20ec.svg";